import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Api from '../../libs/Api';
import translate from '../../libs/i18n';

import NotificationIcon from '../../assets/svgs/NotificationIcon';
import { breakpoints } from '../../ui/variables';
import { NotificationListStyle } from './NotificationListStyle';
import NotificationItem from '../NotificationItem/NotificationItem';

const NotificationList = ({ opened, onClose, notificationList }) => {
  const history = useHistory();
  const language = useSelector((state) => state.settings.language);

  const handleViewNotification = (id, url) => {
    Api.patchViewNotification(id);
    const normalizedUrl = url.startsWith('/') ? url : `/${url}`;
    history.push(normalizedUrl);
  };

  return (
    <NotificationListStyle
      className={`notification-list${opened ? ' opened' : ''}`}
    >
      <div className="notification-list-header">
        <NotificationIcon />
        <span className="title-notification-list">{translate('notifications', language)}</span>
        {window.innerWidth > breakpoints.ipadLandscape.width ? (
          <button type="button" className="close-button" onClick={onClose}>
            +
          </button>
        ) : (
          <button
            type="button"
            className="bottom-close-button"
            onClick={onClose}
          >
            Fechar <span className="close-button-symbol">+</span>
          </button>
        )}
      </div>
      {notificationList.map((notification) => {
        return (
          <NotificationItem
            key={notification.id}
            notification={notification}
            handleViewNotification={handleViewNotification}
          />
        );
      })}
    </NotificationListStyle>
  );
};

NotificationList.propTypes = {
  opened: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  notificationList: PropTypes.arrayOf(PropTypes.object),
};

NotificationList.defaultProps = {
  opened: false,
  notificationList: [],
};

export default NotificationList;
